import { smoothScrollTo } from "../utilities/index";
import { BREAKPOINTS, isMobileView } from "../utilities/index";

(function () {
  "use strict";

  // class ProjectAccordion //========//
  class ProjectAccordion {
    constructor(wrap, reverse) {
      this.wrap = wrap;
      this.trigger = this.wrap.querySelector(".js-accordion-trigger");
      this.ariaLabelOpen = this.trigger.getAttribute("data-aria-open-label");
      this.ariaLabelClose = this.trigger.getAttribute("data-aria-close-label");
      this.content = this.wrap.querySelector(".js-accordion-content");
      this.icons = this.wrap.querySelector(".js-accordion-icons");
      this.iconsLabelInner = this.wrap.querySelector(
        ".js-accordion-icons-label-inner"
      );
      this.iconsLabel = this.wrap.querySelector(".js-accordion-icons-label");
      this.iconsLabelOpen = this.iconsLabel.getAttribute("data-label-open");
      this.iconsLabelClose = this.iconsLabel.getAttribute("data-label-close");

      this.isOpen = this.wrap.classList.contains("is-open");

      this.mq = window.matchMedia(`(max-width: ${BREAKPOINTS.mobile}px)`);
      this.mq.addEventListener("change", () => {
        this.isSP = isMobileView();
        this.onChangeDevice();
      });
      this.isSP = isMobileView();
      this.onChangeDevice();

      this.init();

      setTimeout(() => {
        this.checkHashAndOpen();
      }, 0);
    }

    checkHashAndOpen() {
      const hash = window.location.hash;
      if (hash && this.wrap.id && hash === `#${this.wrap.id}`) {
        // Open the accordion if the hash matches its ID
        if (!this.isOpen) {
          this.toggle();
        }
      }
    }

    init() {
      this.trigger.addEventListener("click", () => {
        if (this.isSP) return;
        this.toggle();
      });

      this.icons.addEventListener("click", () => {
        this.toggle();
      });
    }

    toggle() {
      this.isOpen = !this.isOpen;
      this.wrap.classList.toggle("is-open", this.isOpen);
      this.toggleAriaLabel();

      if (!this.isOpen) {
        if (this.isSP) {
          setTimeout(() => {
            smoothScrollTo(this.scrollPosition, 300);
          }, 0);
        }
      } else {
        this.scrollPosition =
          window.pageYOffset || document.documentElement.scrollTop;
      }
    }

    toggleAriaLabel() {
      this.trigger.setAttribute(
        "aria-label",
        this.isOpen ? this.ariaLabelClose : this.ariaLabelOpen
      );
      this.iconsLabelInner.textContent = this.isOpen
        ? this.iconsLabelClose
        : this.iconsLabelOpen;
    }

    onChangeDevice() {
      if (this.isSP) {
        this.iconsLabel.removeAttribute("aria-hidden");
      } else {
        this.iconsLabel.setAttribute("aria-hidden", "true");
      }
    }
  }

  const accordions = document.querySelectorAll(".c-project-accordion");
  const hasHash = !!window.location.hash;
  accordions.forEach((wrap, index) => {
    const instance = new ProjectAccordion(wrap);
    if (!hasHash && index === 0 && !instance.isOpen) {
      instance.toggle();
    }
  });
})();
